import { render } from "./PositionItem.vue?vue&type=template&id=06ac2352&ts=true"
import script from "./PositionItem.vue?vue&type=script&lang=ts"
export * from "./PositionItem.vue?vue&type=script&lang=ts"

import "./PositionItem.vue?vue&type=style&index=0&id=06ac2352&lang=scss"

import exportComponent from "/home/runner/work/billygrossman.com/billygrossman.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__